import React, { useState } from 'react'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'
import Form from 'antd/lib/form'
import { validatePassword, comparePasswords } from './helpers'
import { Auth } from 'aws-amplify'
import { useSelector } from 'react-redux'
import { setErrorMessage, setShowNewPassword } from '../../redux/auth/actions'
import './Login.css'

const { Item } = Form

const styles = {
    submitButton: {
        marginTop: '1em',
        width: 160,
        borderRadius: 7
    },
    submitContainer: {
        textAlign: 'center',
    },
    error: {
        color: 'red',
        textAlign: 'center',
        fontSize: 14,
    },
}

const NewPassword = ({ onStateChange }) => {
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const errorMessage = useSelector((state) => state.auth.errorMessage)
    const user = useSelector((state) => state.auth.user)

    const completeNewPassword = () => {
        if (comparePasswords(password, confirmPassword) && validatePassword(password)) {
            Auth.completeNewPassword(
                user, // the Cognito User Object
                password // the new password
            ).then((user) => {
                onStateChange('signedIn', {})
                setShowNewPassword(false)
                setErrorMessage('')
            }).catch((e) => {
                if (e.message && e.message.toLowerCase().includes('previous')) {
                    setErrorMessage('This password was recently used. Please choose a password you have not used in the last 5 times.')
                } else {
                    setErrorMessage(e.message || 'Password change failed. Please try again.')
                }
            })
        } else {
            setErrorMessage(
                'Passwords must be at least 8 characters and include at least one number, one uppercase letter, one lowercase letter, and one special character.'
            )
        }
    }

    const checkKeyPress = (e) => {
        const { key, keyCode } = e;
        if (keyCode === 13) {
            completeNewPassword()
        }
    }

    return (
        <>
            <div style={styles.error}>{errorMessage}</div>
            <div style={{ marginTop: '0.64em' }}>
                <div style={{ marginTop: '1em' }}>
                    <span>New Password:</span>
                    <Input.Password
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        className="login-input"
                    />
                </div>
                <div style={{ marginTop: '0.32em' }}>
                    <Input.Password
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        value={confirmPassword}
                        placeholder='Confirm New Password...'
                        onKeyDown={checkKeyPress}
                        className="login-input"
                    />
                </div>
                <div style={styles.submitContainer}>
                    <Button
                        htmlType="submit"
                        onClick={completeNewPassword}
                        size="large"
                        style={styles.submitButton}
                        type="primary"
                    >
                        Change Password
                    </Button>
                </div>
            </div>
        </>
    )
}

export default NewPassword
